import { createRoute } from '@tanstack/react-router'
import { Route as settingsLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => settingsLayoutRoute,
  path: '/settings/documents/terms',
}).lazy(() => import('./documents.terms.lazy').then((d) => d.Route))
